import type { ComponentProps } from "react";
import { cn } from "@/shared/utils/cn";

export function CompactActions({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "grid max-w-[360px] grid-cols-3 gap-2 [&>*]:min-h-12 [&>*]:min-w-11 [&>*]:gap-1.5 [&>*]:rounded-2xl [&>*]:px-1.5 [&>*]:text-sm [&_svg]:size-[18px]",
        className,
      )}
      {...props}
    />
  );
}
